import { render, staticRenderFns } from "./PanelProvisionAgreementsListAdmin.vue?vue&type=template&id=c4d1ab26&scoped=true&"
import script from "./PanelProvisionAgreementsListAdmin.vue?vue&type=script&lang=js&"
export * from "./PanelProvisionAgreementsListAdmin.vue?vue&type=script&lang=js&"
import style0 from "floating-vue/dist/style.css?vue&type=style&index=0&lang=css&"
import style1 from "./PanelProvisionAgreementsListAdmin.vue?vue&type=style&index=1&id=c4d1ab26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d1ab26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4d1ab26')) {
      api.createRecord('c4d1ab26', component.options)
    } else {
      api.reload('c4d1ab26', component.options)
    }
    module.hot.accept("./PanelProvisionAgreementsListAdmin.vue?vue&type=template&id=c4d1ab26&scoped=true&", function () {
      api.rerender('c4d1ab26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelProvisionAgreementsListAdmin.vue"
export default component.exports